import {
    ErrorJson,
    FetchResponse,
    FetchWithJsonOrTextReponseWithError,
    requestUnauthenticatedWithResponseData,
    requestWithErrorHandlingWithoutToken,
    requestWithoutResponseWithErrorHandlingWithoutToken,
} from '../../fetcher';
import {LoginResponse} from './types';
import {AddressEfficiencyRequest, SolarEfficiency, Project, ResultNotFoundRequest} from "../../types";
import {FinancialCalculationResult} from "../authenticated/types";

const platformUrl = process.env.REACT_APP_PLATFORM_URI;

export const userLogin = (body: string) => {
    const url = `${platformUrl}/api/auth/login`;
    return requestWithErrorHandlingWithoutToken<LoginResponse>(url, 'POST', body,);
};

export const userSignup = (body: string) => {
    const url = `${platformUrl}/api/auth/signup`;
    return requestWithoutResponseWithErrorHandlingWithoutToken(url, 'POST', body);
};

export const userSignout = (body: string) => {
    const url = `${platformUrl}/api/auth/logout`;
    return requestWithoutResponseWithErrorHandlingWithoutToken(url, 'POST', body);
};

export const userResetPassword = (body: string) => {
    const url = `${platformUrl}/api/auth/reset`;
    return requestWithoutResponseWithErrorHandlingWithoutToken(url, 'POST', body);
};

export const confirmUserResetPassword = (body: string) => {
    const url = `${platformUrl}/api/auth/confirm-reset`;
    return requestWithoutResponseWithErrorHandlingWithoutToken(url, 'POST', body);
};

export const getRoofEfficiencyUnauthenticated = (body: AddressEfficiencyRequest): Promise<FetchWithJsonOrTextReponseWithError<SolarEfficiency, ErrorJson>> => {
    const url = `${platformUrl}/api/project/explore-anonymous`;
    return requestWithErrorHandlingWithoutToken<SolarEfficiency>(url, 'POST', JSON.stringify(body));
};

export const calculateFinancialData = (systemPower: number, yearlyProduction: number): Promise<FetchResponse<FinancialCalculationResult>> => {
    const url = `${platformUrl}/api/project/financial?systemPower=${systemPower}&yearlyProduction=${yearlyProduction}`;
    return requestUnauthenticatedWithResponseData<FinancialCalculationResult>(url, 'GET');
};

export const getViewableProject = (id: string): Promise<FetchResponse<Project>> => {
    const url = `${platformUrl}/api/project/view-anonymous/${id}`;
    return requestUnauthenticatedWithResponseData<Project>(url, 'GET');
};

export const trackAmplitudeEventUnauthenticated = (eventType: string) => {
    const url = `${platformUrl}/api/project/track-anonymous/${eventType}`;
    return requestUnauthenticatedWithResponseData(url, 'POST');
};

export const sendErrorInvestigationRequestEmail = (body: ResultNotFoundRequest) => {
    const url = `${platformUrl}/api/email`;
    return requestUnauthenticatedWithResponseData(url, 'POST', JSON.stringify(body));
};
